"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsentManagerLanguageKey = exports.LanguageKey = void 0;
/**
 * The language identifier keys
 *
 * @see https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
 */
var LanguageKey;
(function (LanguageKey) {
    /** English */
    LanguageKey["En"] = "en";
    /** Arabic */
    LanguageKey["Ar"] = "ar";
    /** French */
    LanguageKey["Fr"] = "fr";
    /** Spanish */
    LanguageKey["Es"] = "es";
    /** German */
    LanguageKey["De"] = "de";
    /** Italian */
    LanguageKey["It"] = "it";
    /** Japanese */
    LanguageKey["Ja"] = "ja";
    /** Russian */
    LanguageKey["Ru"] = "ru";
    /** Arabic UAE */
    LanguageKey["ArAe"] = "ar-AE";
    /** French */
    LanguageKey["FrFr"] = "fr-FR";
    /** German */
    LanguageKey["DeDe"] = "de-DE";
    /** Austrian German */
    LanguageKey["DeAt"] = "de-AT";
    /** Swiss German */
    LanguageKey["DeCh"] = "de-CH";
    /** Italian */
    LanguageKey["ItIt"] = "it-IT";
    /** Swiss Italian */
    LanguageKey["ItCh"] = "it-CH";
    /** Afrikaans */
    LanguageKey["AfZz"] = "af-ZA";
    /** Bulgarian */
    LanguageKey["BgBg"] = "bg-BG";
    /** Chinese Simplified */
    LanguageKey["ZhCn"] = "zh-CN";
    /** Croatian */
    LanguageKey["HrHr"] = "hr-HR";
    /** Czech */
    LanguageKey["CsCz"] = "cs-CZ";
    /** Danish */
    LanguageKey["DaDk"] = "da-DK";
    /** English UK */
    LanguageKey["EnGb"] = "en-GB";
    /** English CA */
    LanguageKey["EnCa"] = "en-CA";
    /** English UAE */
    LanguageKey["EnAe"] = "en-AE";
    /** Finnish */
    LanguageKey["FiFi"] = "fi-FI";
    /** Greek */
    LanguageKey["ElGr"] = "el-GR";
    /** Hindi */
    LanguageKey["HiIn"] = "hi-IN";
    /** Hungarian */
    LanguageKey["HuHu"] = "hu-HU";
    /** Indonesian */
    LanguageKey["IdId"] = "id-ID";
    /** Japanese */
    LanguageKey["JaJp"] = "ja-JP";
    /** Korean */
    LanguageKey["KoKr"] = "ko-KR";
    /** Lithuanian */
    LanguageKey["LtLt"] = "lt-LT";
    /** Malay */
    LanguageKey["MsMy"] = "ms-MY";
    /** Marathi */
    LanguageKey["MrIn"] = "mr-IN";
    /** Norwegian Bokmål */
    LanguageKey["NbNi"] = "nb-NO";
    /** Polish */
    LanguageKey["PlPl"] = "pl-PL";
    /** Portuguese (Brazil) */
    LanguageKey["PtBr"] = "pt-BR";
    /** Portuguese (Portugal) */
    LanguageKey["PtPt"] = "pt-PT";
    /** Romanian */
    LanguageKey["RoRo"] = "ro-RO";
    /** Russian */
    LanguageKey["RuRu"] = "ru-RU";
    /** Serbian (Latin) */
    LanguageKey["SrLatnRs"] = "sr-Latn-RS";
    /** Swedish */
    LanguageKey["SvSe"] = "sv-SE";
    /** Tamil */
    LanguageKey["TaIn"] = "ta-IN";
    /** Thai */
    LanguageKey["ThTh"] = "th-TH";
    /** Turkish */
    LanguageKey["TrTr"] = "tr-TR";
    /** Ukrainian */
    LanguageKey["UkUa"] = "uk-UA";
    /** Vietnamese */
    LanguageKey["ViVn"] = "vi-VN";
    /** Zulu */
    LanguageKey["ZuZa"] = "zu-ZA";
    /** USA */
    LanguageKey["EnUS"] = "en-US";
    /** Australia */
    LanguageKey["EnAu"] = "en-AU";
    /** Belgium */
    LanguageKey["FrBe"] = "fr-BE";
    /** Quebec */
    LanguageKey["FrCa"] = "fr-CA";
    /** French (Switzerland) */
    LanguageKey["FrCh"] = "fr-CH";
    /** Ireland */
    LanguageKey["EnIe"] = "en-IE";
    /** Dutch */
    LanguageKey["NlNl"] = "nl-NL";
    /** Dutch (Belgium) */
    LanguageKey["NlBe"] = "nl-BE";
    /** Spanish (Castellano) */
    LanguageKey["EsEs"] = "es-ES";
    /** Spanish (Latin America & Caribbean) */
    LanguageKey["Es419"] = "es-419";
    /** Chinese (Traditional) */
    LanguageKey["ZhHk"] = "zh-HK";
    /** Hebrew (Israel) */
    LanguageKey["HeIl"] = "he-IL";
    /** English (New Zealand) */
    LanguageKey["EnNz"] = "en-NZ";
    /** Estonian (Estonia) */
    LanguageKey["EtEe"] = "et-EE";
    /** Icelandic (Iceland) */
    LanguageKey["IsIs"] = "is-IS";
    /** Latvian (Latvia) */
    LanguageKey["LvLv"] = "lv-LV";
    /** Maltese (Malta) */
    LanguageKey["MtMt"] = "mt-MT";
    /** Slovak (Slovakia) */
    LanguageKey["SkSk"] = "sk-SK";
    /** Slovenian (Slovenia) */
    LanguageKey["SlSl"] = "sl-SL";
})(LanguageKey = exports.LanguageKey || (exports.LanguageKey = {}));
exports.ConsentManagerLanguageKey = {
    En: LanguageKey.En,
    FrFr: LanguageKey.FrFr,
    DeDe: LanguageKey.DeDe,
    ItIt: LanguageKey.ItIt,
    PtBr: LanguageKey.PtBr,
    Es419: LanguageKey.Es419,
    EsEs: LanguageKey.EsEs,
    CsCz: LanguageKey.CsCz,
    DaDk: LanguageKey.DaDk,
    FiFi: LanguageKey.FiFi,
    ElGr: LanguageKey.ElGr,
    LtLt: LanguageKey.LtLt,
    NbNi: LanguageKey.NbNi,
    PlPl: LanguageKey.PlPl,
    RoRo: LanguageKey.RoRo,
    RuRu: LanguageKey.RuRu,
    SrLatnRs: LanguageKey.SrLatnRs,
    SvSe: LanguageKey.SvSe,
    ArAe: LanguageKey.ArAe,
    JaJp: LanguageKey.JaJp,
    KoKr: LanguageKey.KoKr,
    ZhCn: LanguageKey.ZhCn,
    ZhHk: LanguageKey.ZhHk,
    AfZz: LanguageKey.AfZz,
    BgBg: LanguageKey.BgBg,
    HrHr: LanguageKey.HrHr,
    HuHu: LanguageKey.HuHu,
    IdId: LanguageKey.IdId,
    MsMy: LanguageKey.MsMy,
    HiIn: LanguageKey.HiIn,
    MrIn: LanguageKey.MrIn,
    TaIn: LanguageKey.TaIn,
    ThTh: LanguageKey.ThTh,
    TrTr: LanguageKey.TrTr,
    UkUa: LanguageKey.UkUa,
    ViVn: LanguageKey.ViVn,
    NlNl: LanguageKey.NlNl,
    HeIl: LanguageKey.HeIl,
};
//# sourceMappingURL=enums.js.map